import React from 'react'

function AttorneyCaseSummarySection() {
  return (
    <div>
      {/* https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/caseSummary.png */}
       <div className='pt-4 lg:pt-10 border border-1 p-2 lg:p-10 border-blue-800 rounded bg-blue-800 '
          >
              <div className='text-sm lg:text-md  font-bold text-white'>For Attorneys</div>
              <div className='lg:text-2xl capitalize mt-2 lg:mt-10 text-white'>Find cases of your interest and request the client for more case information </div>
              <img src="https://d2i01uic15h4nn.cloudfront.net/websiteStaticImages/caseSummary.png" alt="Case Summary" className='mt-4 lg:mt-10 w-full '/>
          </div>
    </div>
  )
}

export default AttorneyCaseSummarySection
